/**
 * Registry of open CodSheet instances, ordered by opening time (last = topmost).
 *
 * Exists for the Android hardware-back policy (docs/NavigationGuards.md):
 * back press → topmost sheet pops a step or closes (guard-respecting) → else
 * router.back(). Kept as a plain module so both the back handler and App.vue's
 * `kontySheetRegistry` provide (the shared CodSheet's AD-3 seam) can use it
 * without a store. The handle contract is the kit's type.
 */
import type { SheetHandle } from 'app-components'

export type { SheetHandle }

const stack: SheetHandle[] = []

export function registerSheet(handle: SheetHandle): void {
  stack.push(handle)
}

export function unregisterSheet(handle: SheetHandle): void {
  const i = stack.indexOf(handle)
  if (i !== -1) stack.splice(i, 1)
}

/** Give the topmost open sheet a chance to consume a back press. */
export function handleSheetBack(): boolean {
  const top = stack[stack.length - 1]
  return top ? top.handleBack() : false
}

/** Number of open sheets (used by tests and the back handler). */
export function openSheetCount(): number {
  return stack.length
}
